
import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatDate,
  formatNumberTwoDecimal,
  formatNumberTwoDecimalWithRounding,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatDscr
} from "./formatters";

const WEIGHTED_MATURITY = "681d7cfd-2e11-11e9-ac70-0242ac140002";
const WEIGHTED_AVERAGE_INTEREST_RATE = "681d7d2d-2e11-11e9-ac70-0242ac140002";
const TOTAL_OUTSTANDING_DEBT = "681d7d3d-2e11-11e9-ac70-0242ac140002";
const CASH_EQUITY = "0bf25d21-ad90-4ab7-92ce-5dfc4eb3eaf1";
const UNFUNDED_COMMITTED_DEBT = "681d7d4b-2e11-11e9-ac70-0242ac140002";
const LTV = "681d7d59-2e11-11e9-ac70-0242ac140002";
const DEBT_YIELD = "681d7d69-2e11-11e9-ac70-0242ac140002";
const DSCR = "681d7d7b-2e11-11e9-ac70-0242ac140002";
const FIXED_FLOATING_HEDGED_DEBT_PERCENT = "681d7d8f-2e11-11e9-ac70-0242ac140002";
const FIXED_HEDGED_PV01 = "681d7da5-2e11-11e9-ac70-0242ac140002";
const FLOATING_PV01 = "681d7dbc-2e11-11e9-ac70-0242ac140002";
const NOI = "681d7dd5-2e11-11e9-ac70-0242ac140002";
const PROPERTY_VALUE = "681d7def-2e11-11e9-ac70-0242ac140002";
const PREPAYMENT = "681d7e0c-2e11-11e9-ac70-0242ac140002";
const RSF = "681d7e2a-2e11-11e9-ac70-0242ac140002";
const MF_UNITS = "681d7e4a-2e11-11e9-ac70-0242ac140002";
const DEBT_RSF = "681d7e6c-2e11-11e9-ac70-0242ac140002";
const DEBT_MF_UNIT = "681d7e91-2e11-11e9-ac70-0242ac140002";
const MAX_RECOURSE = "681d7eb7-2e11-11e9-ac70-0242ac140002";
const AGGREGATE_EQUITY = "681d7ede-2e11-11e9-ac70-0242ac140002";
const PROJECTED_RATE = "681d7f07-2e11-11e9-ac70-0242ac140002";
const OCCUPANCY = "43dfd306-0d7b-4a6c-9564-df852fafe37b";
const LTV_SUBORDINATE = "b8e70ce0-c9b2-11e9-a4f9-00ff12c3b408";
const DEBT_YIELD_SUBORDINATE = "b8e70d11-c9b2-11e9-a4f9-00ff12c3b408";
const DSCR_LENDER = "b8e70d1b-c9b2-11e9-a4f9-00ff12c3b408";
const DSCR_LENDER_SUBORDINATE = "b8e70d21-c9b2-11e9-a4f9-00ff12c3b408";
const DSCR_ACTUAL = "b8e70d27-c9b2-11e9-a4f9-00ff12c3b408";
const DSCR_ACTUAL_SUBORDINATE = "b8e70d2e-c9b2-11e9-a4f9-00ff12c3b408";
const NOI_ACTUAL = "b8e70d33-c9b2-11e9-a4f9-00ff12c3b408";
const REFI_PROCEEDS = "bc486c32-8f9e-11ea-9df5-2c4d543da462";
const REFI_CASH_OUT = "82067a07-55ae-41fd-87c6-09cdf27819f5";
const ALL_IN_EFFECTIVE_RATE = "e26053b1-b16a-414b-b95a-a710050a9f65";

export default {
  [CASH_EQUITY]: formatCurrency,
  [WEIGHTED_MATURITY]: notImplemented,
  [WEIGHTED_AVERAGE_INTEREST_RATE]: formatRate,
  [TOTAL_OUTSTANDING_DEBT]: formatCurrency,
  [UNFUNDED_COMMITTED_DEBT]: formatCurrency,
  [LTV]: formatRate,
  [DEBT_YIELD]: formatRate,
  [DSCR]: formatDscr,
  [FIXED_FLOATING_HEDGED_DEBT_PERCENT]: formatDisplayValue,
  [FIXED_HEDGED_PV01]: notImplemented,
  [FLOATING_PV01]: notImplemented,
  [NOI]: formatCurrency,
  [PROPERTY_VALUE]: formatCurrency,
  [PREPAYMENT]: formatCurrency,
  [RSF]: formatNumberTwoDecimalWithRounding,
  [MF_UNITS]: formatDecimalNoDecimal,
  [DEBT_RSF]: formatCurrencyTwoDecimal,
  [DEBT_MF_UNIT]: formatCurrency,
  [MAX_RECOURSE]: notImplemented,
  [AGGREGATE_EQUITY]: formatCurrency,
  [PROJECTED_RATE]: formatRate,
  [OCCUPANCY]: formatRate,
  [LTV_SUBORDINATE]: formatRate,
  [DEBT_YIELD_SUBORDINATE]: formatRate,
  [DSCR_LENDER]: formatDscr,
  [DSCR_LENDER_SUBORDINATE]: formatDscr,
  [DSCR_ACTUAL]: formatDscr,
  [DSCR_ACTUAL_SUBORDINATE]: formatDscr,
  [NOI_ACTUAL]: formatCurrency,
  [REFI_PROCEEDS]: formatCurrency,
  [REFI_CASH_OUT]: formatCurrency,
  [ALL_IN_EFFECTIVE_RATE]: formatRate
};
